import { Link, NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { FileText, Image, Images, ListTree, LogOut, ExternalLink, LayoutTemplate, Clapperboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/admin/homepage", label: "Homepage", icon: LayoutTemplate },
  { to: "/admin/pages", label: "Pages", icon: FileText },
  { to: "/admin/media", label: "Media Library", icon: Image },
  { to: "/admin/gallery", label: "Gallery", icon: Images },
  { to: "/admin/videos", label: "Social Gallery", icon: Clapperboard },
  { to: "/admin/menu", label: "Menu", icon: ListTree },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (user === null) return <div className="min-h-screen bg-slate-50" />;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="flex min-h-screen bg-slate-50 font-body text-slate-800">
      <aside className="flex w-64 shrink-0 flex-col bg-brand-ink p-5 text-white">
        <Link to="/admin" className="font-heading text-lg font-bold">JKJ Admin</Link>
        <p className="mt-1 text-xs text-white/40">Content Management</p>
        <nav className="mt-8 flex flex-col gap-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`admin-nav-${l.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-brand-magenta text-white" : "text-white/70 hover:bg-white/10"}`}>
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto space-y-2 pt-6">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-white/60 hover:bg-white/10">
            <ExternalLink className="h-4 w-4" /> View site
          </a>
          <button data-testid="admin-logout" onClick={() => { logout(); nav("/admin/login"); }} className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-white/60 hover:bg-white/10">
            <LogOut className="h-4 w-4" /> Logout
          </button>
          <p className="px-3 pt-2 text-xs text-white/30">{user.email}</p>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden p-8"><Outlet /></main>
    </div>
  );
}
